<template>
  <div class="pt-10 page-container">
    <!-- 상단 이미지 -->
    <section class="section-image" v-if="!isBuynowWooriCrowd">
      <img src="@/assets/images/landing/SectionBenefit/schedule.png" alt="schedule" />
    </section>

    <!-- 페이지 제목 -->
    <section class="page-title text-center my-6" v-if="!isBuynowWooriCrowd">
      <h2>365일 매일! 오전 정산!</h2>
      <p>주말 매출도 기다림 없이</p>
    </section>

    <!-- 이용 약관 체크박스 -->
    <Agreements :valid.sync="validAgreements" :terms.sync="terms" />

    <!-- 추천인 코드 입력 -->
    <section class="mt-6" v-if="!isBuynowWooriCrowd">
      <h3>내 추천인 코드 입력 (선택)</h3>
      <v-text-field
        v-model.trim="referralCode"
        hide-details
        ref="referralCode"
        label="추천인 코드"
      />
    </section>

    <section class="mt-6 mb-10">
      <BasicButton
        @click="next()"
        :loading="loading"
        :disabled="loading || !validAgreements"
        depressed
        class="font-weight-bold"
      >
        {{ organization ? `${organization.name} ` : '' }}시작하기
      </BasicButton>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import { getRedirectUriAndRemove } from '@/util'
import Agreements from '@/components/signup/agreements/Agreements.vue'
const referralCodeName = 'referralCode'
export default {
  components: {
    Agreements,
  },
  data() {
    return {
      // 약관 관련
      validAgreements: false,
      terms: null,
      // 추천인 코드
      referralCode: null,
      loading: false,
    }
  },
  computed: {
    ...mapState('auth', ['me']),
    ...mapState('myfinbiz', ['organization']),
    ...mapGetters('myfinbiz', ['platformCode']),
    ...mapGetters('auth', {
      storeReferralCode: referralCodeName,
      registerWooriCrowd: 'registerWooriCrowd',
    }),
    isBuynowWooriCrowd() {
      console.log('platformCode', this.platformCode)
      return this.platformCode === 'buynow-woori-crowd'
    },
  },
  created() {
    _meta({
      titles: ['서비스약관동의'],
    })
    const cookieReferralCodeName = this.$cookies.get(referralCodeName)
    if (cookieReferralCodeName) {
      this.referralCode = cookieReferralCodeName
    }
  },
  methods: {
    ...mapMutations('status', ['refresh']),
    ...mapActions('auth', ['addSimpleUser', 'syncMe']),
    ...mapActions('nice', {
      addNiceUser: 'addUser',
    }),
    ...mapActions('account', ['getAccounts']),
    ...mapActions('agreement', ['postServiceTermsAgreements']),
    ...mapActions('myfinbiz', ['organizationsAddCustomer']),
    ...mapMutations('status', ['refresh']),
    async movePage() {
      let redirectUri = getRedirectUriAndRemove()
      if (!redirectUri) {
        redirectUri = '/'
      }

      await this.$router.replace(redirectUri)
    },
    async next() {
      if (this.loading || !this.validAgreements) return false

      try {
        this.loading = true
        // 회원 가입
        await this.addUser()
        // 약관 동의
        await this.addAgreements()
        // 사용하고 난 쿠키는 삭제
        this.$cookies.remove(referralCodeName)
        await this.refresh()
        return await this.movePage()
      } catch (e) {

        // 추천인코드 잘못된 경우 처리
        const referralCodeError = e.data?.referralCode?.[0]
        if (referralCodeError) {
          await this.$swal.basic.error({
            html: referralCodeError,
          })

          this.referralCode = null
          this.$refs.referralCode?.focus()
          return
        }

        throw e
      } finally {
        this.loading = false
      }
    },

    /**
     * 회원 가입
     */
    async addUser() {
      const user = {
        id: this.$cookies.get('businessLicenseNumber'),
        businessLicenseNumber: this.$cookies.get('businessLicenseNumber'),
        firebaseToken: this.$cookies.get('firebaseToken'),
        companyName: this.$cookies.get('companyName'),
        referralCode: this.referralCode,
      }
      // 로그인이 되어있는상태에서 회원가입 페이지로 진입하면 회원 생성을 안한다
      if (!this.me) {
        await this.addSimpleUser({
          businessLicenseNumber: user.businessLicenseNumber,
          referralCode: this.referralCode || null, // 공백이면 null로
        }) // 카카오 대신 들어온 로그인
        await this.addNiceUser(user) // nice
      }
      await this.syncMe()
      try {
        await this.organizationsAddCustomer()
      } catch (e) {
        console.log(e)
      }
    },

    /**
     * 약관 동의
     */
    async addAgreements() {
      await this.postServiceTermsAgreements(this.terms)
      await this.getAccounts()
    },
  },
}
</script>

<style lang="scss" scoped>
.section-image {
  img {
    width: 91px;
    display: block;
    margin: 0 auto;
  }
}
</style>
